export enum MediaTypes {
  ExcelFile = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CsvFile = 'text/csv',
  ZipFile = 'application/zip',
}
